import { trackPageRequest } from './appComponents/shared/PageLoadingService';
import { authenticatedPut } from './appComponents/shared/AuthenticatedAPI';
import Amplify, { Auth, Storage, API } from 'aws-amplify'
import './../styles/Browser.css'; // Tell webpack that Button.js uses these styles
import './../index.css';
import React, {Component, Fragment, useRef, useLayoutEffect} from 'react';
import {isMobile} from 'react-device-detect';
import { Mosaic, OrbitProgress, ThreeDot } from "react-loading-indicators";

import { Chart } from 'react-google-charts';

import awsconfig from '../aws-exports.js';

import { navigationHandler, routeProps } from '../utilities/navigator.js';
import LoadingIcons from 'react-loading-icons'
import LeftNavBar  from '../components/LeftNavBar';
import blenderPrivateKey  from '../blenderData/generalPrivateKey.js';
import { tokenLifeTimeLimit, checkValidAuthTokenIntervalPeriod_ms,  LENDERBLOCKADMINWHITELIST} from '../blenderData/securityConfigurations';
import { Link, useParams } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css'
import {  
  Button, 
  ButtonContent,
  ButtonGroup,
  Modal, 
  Header, 
  Image, 
  Container,
  ListList,
  ListItem,
  ListIcon,
  Icon,
  ListHeader,
  ListDescription,
  ListContent,
  List,
  FormField, 
  Form, 
  Radio,
} from 'semantic-ui-react';
import { ethers } from 'ethers';
// var PrivateKeyProvider = require("truffle-privatekey-provider");
import axios from 'axios';


import CampaignContract_latest from '../ethereum/build/latest/Campaign.json';
import CampaignFactoryContract_latest from '../ethereum/build/latest/CampaignFactory.json';
import AccountManagementMobileRender from './accountManagement/AccountManagementMobileRender.jsx';
import AccountManagementDesktopRender from './accountManagement/AccountManagementDesktopRender.jsx';

const PrivateKeyProvider = null; // legacy provider reference retained; original require was already disabled

var primaryLanguage;

const fileDialog = require('file-dialog')
const Web3 = require('web3');

var AWS = require('aws-sdk');

var mimemessage = require('mimemessage');

Auth.configure(awsconfig); 
Storage.configure(awsconfig);
var checkValidAuthTokenInterval;

var cognitoID;
var currentUser;
var currentUserCap;


var primaryDisplayCurrency;
var secondaryDisplayCurrency;
var publicKey;
var corporateBackedUsernamesArray;
var emailAddress;
var that;

let applicantUsername;


var newMemberRegisterBool;

var addedContracts = []
var blenderData;
var userWishlist = [];
var preSortedContractsArray = []
var allContracts;
var username_wallet;
var allContractsLooper;

var filterSwitchReloaded;
var retrievedContractsArray
var creditLineArray;
let creditLineAddressArray;
var wishlistArray;
var recentlyViewedContractsArray;
var recentlyViewedContracts;
var topMoversArray;
var loanAgreementArray;

var bScoreFilterMax, ratingMax, intRateMax, lenderCtMax;
var bScoreFilterMin, ratingMin, intRateMin, lenderCtMin;

let scrollHeaderInterval;

var publicKey
var rand1;
var rand2;
var rand3;
var rand4;
var randSum;
var currentUser; 
var filterSwitch;
var chartDayRange = 90

let mediaMapArrayUserMap = {}


let searchTimer;



 


let lastNonce;
var USDEtherConversionRate;
var tokenID;
var cognitoID;
var publicKey;
var privateKey;
var currentUser;
let cardEntryFormTimer;
let exitFundWalletTimer;
let firstName ;
let lastName;
let fullAddress;
let postalCode; 
let fullName;
let street;
let city;
let state;
let country;
let resultMessageTimer;
let cardFundComponent;
let countryCodes;
let countryNames;
let countryCodeSwappedJSONList;
let optionCountryCodeSwappedJSON;
let countryCodeSwappedJSON;
let proposeGasPrice;



const debounce = require('lodash/debounce');

var PIXELAJUST = 725;


var web3;
var privateKey;
var pageOrigin;

var allValues
var chartData
var rand1; 
var rand2;
var rand3;
var rand4;
var allDaysElapsed;
var joinDateSecs;
var openContracts;
var totalBorrContracts 
var blenderScore 
var notificationCount
var lenders
var notifs
var chartDayRange;
var compoundedDebtSum;
var currentLentSum;

let stakedContractsList;
let primaryDisplayPrice;
let secondaryDisplayPrice;
let forexJSON;


var walletBalance;
var cognitoID;
var currentUser;
var currentUserCap;



var squareCustomerID;

var corporateBackedUsernamesArray;

var openBorrowingContractsDetails_loanAgreement = []
var openLendingContractsDetails_loanAgreement = []
var openStakingContractsDetails_loanAgreement = []

var addedContracts_creditLine = []
var addedContracts_loanAgreement = []

var noAccountsWarning_creditLine;
var noAccountsWarning_loanAgreement;

var exitTutorialTimer_3, exitTutorialTimer_2, exitTutorialTimer_1;
var buttonColorFlashIntervalDefault;
var flashCounter = 0;

let mediaArray;
let mediaArrayMap;

var fundWalletPromptDidBool = false;
let verifyOverlayShownBool = false;






















let monthLengtheningEnum = {
    JAN: 'January',
    FEB: 'February',
    MAR: 'March',
    APR: 'April',
    MAY: 'May',
    JUN: 'June',
    JUL: 'July',
    AUG: 'August',
    SEP: 'September',
    OCT: 'October',
    NOV: 'November',
    DEC: 'December',
}


class AccountManagementComponent extends Component {

    constructor() {
      super()


    
      this.state = {
          usernameText: '',
          passwordText: '',
          touched: false,
          navigationDestinationObject: {
            navigationRoute: '',
          },
          button_recentApp_opacity: 1,
          button_pendingApp_opacity: 1,
          pendingApplicationsList: [],
          requestedAwaitingDocumentList: [],
          messageLineArray: [],
          submittedDocumentIDList: [],
          ableToFinalizeAndApproveBool: false,
          clientCorrespondenceMsgTextString: '',
          applicantUserFirstName: null,
          showLoaderOverlay: false,
          overheadApplicationApprovalString: '',
          applicationApprovedStatus: false,
          applicantUserFirstName: '',
          applicantEmailAddress: '',
          applicantUsername: '',
          messageInflight: false,
          didMessageSend: false,
          walletBalance: 0,
          compoundedDebtSum: 0, 
          currentLentSum: 0,
          moneyTransactionPreset: 'deposit',
          moneyTransactionLiveValue: null,
          creditLineArray: [],
          recentlyViewedContractsArray: [],
          wishlistArray: [],
          searchResultContracts: [],
          searchedContractsArray: [],
          search: null, 

          mediaDeleteOverlay: false,
          welcomeOverlay: false,
          socialOverlay: false,
          mediaMapArrayUserMap: {},
          mediaMapArray: [],
          socialOverlayData_username: '',
          socialOverlayData_fullName: '',
          socialOverlayData_imageURI: null,
          socialOverlayData_bioString: '',
          socialOverlayData_contractAddress: null,
          commentReplyID: null,
          commentInitMediaFileName: null,
          commentIsWritingMediaFileName: null,
          newCommentStringInput: null,
          commentViewerMediaFileName: null,
          likedMediaItemMap: {},
          subscriberBenefitsArray: [],

          inviteOverlay: false,
          emailAddress_phoneNumber: null,
          last4AccountNumbers_bankAccount: null,


          successfulDepositOverlay: false,
          successfulUpdateOverlay: false,
          successfulWithdrawalOverlay: false,

          currentUserProfilePicture: null,

          newCaptionStringInput: null,
          captionActivelyEditingURI: null,
          bioActivelyEditingBool: false,
          fileDialogOverlay: false,
          mediaItemToDelete: null,
          selectPrimaryLanguageOverlay: false,
          publicDisplayNameEditOverlay: false,
          newDynamicPublicUsername: null,
          selectedLanguage: null,
          mode_light_dark: null,
          currentUser: null,
          errorTags: null,
          lastMediaItemIndexScrolled: 0,

      };
      that = this

      
      


      newMemberRegisterBool = false;

      web3 = new Web3(new Web3.providers.HttpProvider("https://rpc.gnosischain.com/"));

  }

  async componentDidMount(){

      // Resolve the signed-in username before profile image paths use it.
      try {
          const authenticatedUser = await Auth.currentAuthenticatedUser();
          currentUser = authenticatedUser.username;
          if (!currentUser) {
              throw new Error('Authenticated username is unavailable');
          }
          currentUserCap = currentUser.toUpperCase();
          cognitoID = authenticatedUser.signInUserSession.idToken.jwtToken;
      } catch (error) {
          that.setState({
              navigationDestinationObject: {
                  navigationRoute: '/welcome',
              },
          });
          return;
      }


      if(isMobile){
        // window.open("https://lenderblockcorp.com/blenderplatform","_self")
      }

      that.setState({
        selectedLanguage: localStorage.getItem('primaryLanguage'),
        mode_light_dark: localStorage.getItem('mode_light_dark'),
        errorTags: null,
        lastMediaItemIndexScrolled: 0,
      })

      that.buildData()

      if(routeProps && routeProps.prompt == 'welcome'){
        that.setState({
          welcomeOverlay: true
        })
      }

      let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

                  that.setState({
                    currentUserProfilePicture: profilePicture_uri
                  })

                  Storage.get(
                    `${currentUser.toLowerCase()}/profilePicture.jpg`,
                    {
                        bucket: "platform-user-media-uploads",
                        level: "public"
                    }
                  ).then((res) => {
                    trackPageRequest(fetch(
                      res
                    )).then((image) => {
                      if(image.status == 200){
                        profilePicture_uri = res;
                      }
                      that.setState({
                        currentUserProfilePicture: profilePicture_uri
                      })
                    })
                  })
  }

  uploadSocialData(){

    authenticatedPut('api1169ba1e', '', { 
        headers: { Authorization: `Bearer ${cognitoID}` },
        body: { 
            category: 'db',
            tableName: 'socialUserData', 
            primaryKey: currentUser, 
            requestOperation: 'update',
            updateExpression: 
                `SET 
                    weblink1 = :weblink1,
                    weblink2 = :weblink2,
                    weblink3 = :weblink3,
                    bioString = :bioString,
                    mediaArray = :mediaArray
                `
            ,
            expressionAttributeValues: { 
                ':weblink1': that.state.weblink1,
                ':weblink2': that.state.weblink2,
                ':weblink3': that.state.weblink3,
                ':bioString': that.state.socialOverlayData_bioString,
                ':mediaArray': that.state.mediaArray,
            }
        }
    }).then((res) => {

        that.setState({
            editDataOverlay: false,
            successOverlay: true
        }, ()=>{
            setTimeout(() => {
                that.initialMount()
            }, 5000)
        })
    })
  }

  

  updatePrimaryLanguage(selectedLanguage){
    authenticatedPut('api1169ba1e', '', { 
      headers: { Authorization: `Bearer ${cognitoID}` },
      body: { 
        category: 'db',
        tableName: 'general', 
        primaryKey: 'languageSubscriberMap', 
        requestOperation: 'update',
        updateExpression: `SET languageSubscriberMap.#username = :primaryLanguage`, 
        expressionAttributeValues: { 
          ':primaryLanguage': selectedLanguage
        },
        expressionAttributeNames: {
          '#username': currentUser.toLowerCase()
        }
      }
    }).then(() => {
      localStorage.setItem('primaryLanguage', selectedLanguage)

      that.setState({
        successfulUpdateOverlay: true
      })
      setTimeout(() => {
        that.componentDidMount()

        that.setState({
          successfulUpdateOverlay: false
        })
      }, 3000)
    })
  }

  updateProfilePhoto(){
    fileDialog({ 
      multiple: false, 
      accept: ['image/*'] 
    }).then(file => {
        const data = new FormData()
        data.append('file', file[0])

        
          const reader = new FileReader();
      
          reader.onload = (e) => {
            const uri = e.target.result;


            trackPageRequest(axios.get(uri, { responseType: 'arraybuffer' })).then((res) => {                                                          

                let fileName = `${currentUser}/${'profilePicture'}.jpg`

                try{
                    Storage.put(
                        fileName,
                        // uri,
                        res.data,
                        { 
                          level: 'public',
                        }
                    ).then((res) => {
                        that.setState({
                          successfulUpdateOverlay: true
                        })
                        setTimeout(() => {
                          that.setState({
                            successfulUpdateOverlay: false
                          })
                        }, 3000)
                      })
                } catch(err) {
                }                                                           

            })

          };
      
          reader.readAsDataURL(file[0]);  
          
    })

  }

  buildData(){

    trackPageRequest(Auth.currentAuthenticatedUser()).then((res) => {
      currentUser = res.username
      cognitoID = res.signInUserSession.idToken.jwtToken
      currentUserCap = currentUser.toUpperCase()
      that.setState({ 
        currentUser,
        searchActivity: false,
        verifyIDOverlay: false,
        commentReplyID: null,
        commentInitMediaFileName: null,
        commentIsWritingMediaFileName: null,
        newCommentStringInput: null,
        newCaptionStringInput: null,
        captionActivelyEditingURI: null,
        bioActivelyEditingBool: false,
        mediaDeleteOverlay: false,
        publicDisplayNameEditOverlay: false,
        newDynamicPublicUsername: null,

     })
     
      
     










      let profilePicture_base64 = null;
      let profilePicture_uri = null;
      let bioString = 'No Bio :('

      profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${currentUser.toLowerCase()}`;

      // Media fetch is independent of the optional profile avatar; a missing avatar
      // must never prevent the user's uploaded posts from loading.
      that.setState({ socialOverlayData_imageURI: profilePicture_uri });
      Storage.get(`${currentUser.toLowerCase()}/profilePicture.jpg`, {
        bucket: 'platform-user-media-uploads', level: 'public'
      }).then(uri => {
        if (!uri) return;
        return trackPageRequest(fetch(uri)).then(response => {
          if (response && response.ok) {
            that.setState({ socialOverlayData_imageURI: uri });
          }
        });
      }).catch(() => {});
      mediaMapArrayUserMap = {};
      buildMediaData();
      function buildMediaData(){
          authenticatedPut('api1169ba1e', '', { 
            headers: { Authorization: `Bearer ${cognitoID}` },
            body: { 
                category: 'db',
                tableName: 'socialUserData', 
                primaryKey: String(currentUser), 
                requestOperation: 'get',
            }
          }).then((userData) => {



              if(userData.hasOwnProperty('Item')){
                if(userData.Item.hasOwnProperty('bioString')){
                  bioString = String(userData.Item.bioString)
                } else {
                  bioString = 'No Bio :('
                }
                
                that.setState({
                  socialOverlayData_bioString: bioString,
                })
                
                let mediaArray = []

                if(userData.Item.hasOwnProperty('dynamicPublicUsername')){
                  that.setState({
                    newDynamicPublicUsername: userData.Item.dynamicPublicUsername
                  })
                }

                if(userData.Item.hasOwnProperty('mediaArray')){
                  mediaArray = userData.Item.mediaArray
                }
                
                let mediaMapArray = []

                loopUserMediaArray(0)
                function loopUserMediaArray(m){

                  if(m<=mediaArray.length-1){
                    let thisFileName = mediaArray[m]
                    let caption = '...'
                    let uploadTimestamp = 0;
                    let likesArray = [];
                    let commentsMapArray = [];
                    // Publish a media card as soon as its S3 URL is available.
                    // Comment metadata can finish later without blocking the gallery.
                    let published = false;
                    function publishMedia(uri) {
                      if (!published && uri) {
                        mediaMapArray.unshift({
                          mediaURI: uri, mediaFileName: thisFileName,
                          mediaItemCaption: caption, uploadTimestamp,
                          likesArray, commentsMapArray, publisherUsername: currentUser
                        });
                        published = true;
                        mediaMapArray.sort((a,b) => Number(b.uploadTimestamp)-Number(a.uploadTimestamp));
                        that.setState({ mediaMapArray: [...mediaMapArray] });
                        loopUserMediaArray(m+1);
                      } else if (published) {
                        const found = mediaMapArray.find(item => item.mediaFileName === thisFileName);
                        if (found) Object.assign(found, { mediaItemCaption: caption, uploadTimestamp, likesArray, commentsMapArray });
                        that.setState({ mediaMapArray: [...mediaMapArray] });
                      }
                    }

                    Storage.get(
                        thisFileName,
                        {
                            bucket: "platform-user-media-uploads",
                            level: "public"
                        }
                    ).then((res) => {
                        if(res){

                            authenticatedPut('api1169ba1e', '', { 
                                headers: { Authorization: `Bearer ${cognitoID}` },
                                body: { 
                                    category: 'db',
                                    tableName: 'mediaUploads', 
                                    primaryKey: String(thisFileName), 
                                    requestOperation: 'get',
                                }
                            }).then((mediaData) => {
                                mediaData = mediaData && mediaData.Item ? mediaData : { Item: {} };
                                if(mediaData.hasOwnProperty('Item')){

                                    if(mediaData.Item.hasOwnProperty('caption')){
                                      caption = String(mediaData.Item.caption)
                                    }
                                    if(mediaData.Item.hasOwnProperty('uploadTimestamp')){
                                      uploadTimestamp = String(mediaData.Item.uploadTimestamp)
                                    }
                                    if(mediaData.Item.hasOwnProperty('likesArray')){
                                      likesArray = mediaData.Item.likesArray
                                    }
                                    if(mediaData.Item.hasOwnProperty('commentsMapArray')){
                                      commentsMapArray = mediaData.Item.commentsMapArray
                                    }



                                    function loopCommentsArray(c){

                                      if(commentsMapArray.length-1 >= c && commentsMapArray.length > 0){
                                        let thisComment = commentsMapArray[c]
                                        let thisSender = thisComment.sender

                                        let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
    
                                        Storage.get(
                                          `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                          {
                                              bucket: "platform-user-media-uploads",
                                              level: "public"
                                          }
                                        ).then((res) => {
                                          trackPageRequest(fetch(
                                            res
                                          )).then((image) => {

                                            if(image.status == 200){
                                              profilePicture_uri = res;
                                            }
                                            commentsMapArray[c]['profilePictureURI'] = profilePicture_uri
                                            commentsMapArray[c]['mediaFileName'] = thisFileName

                                            let commentsReplyMapArray = []
                                            
                                            authenticatedPut('api1169ba1e', '', { 
                                              headers: { Authorization: `Bearer ${cognitoID}` },
                                              body: { 
                                                  category: 'db',
                                                  tableName: 'mediaUploadComments', 
                                                  primaryKey: commentsMapArray[c].messageID, 
                                                  requestOperation: 'get',
                                              }
                                            }).then((messageData) => {

                                              if(messageData.hasOwnProperty('Item')){

                                                commentsMapArray[c]['likesArray'] = messageData.Item.likesArray

                                                if(messageData.Item.hasOwnProperty('commentsReplyMapArray')){
                                                  commentsReplyMapArray = messageData.Item.commentsReplyMapArray
                                                }
                                              
                                                function loopCommentsReplyArray(r){

                                                  if(commentsReplyMapArray.length-1 >= r && commentsReplyMapArray.length > 0){
                                                    let thisComment = commentsReplyMapArray[r]
                                                    let thisSender = thisComment.sender

                                                    let profilePicture_uri = `https://api.dicebear.com/7.x/identicon/png?size=140&seed=${thisSender.toLowerCase()}`;
                
                                                    Storage.get(
                                                      `${thisSender.toLowerCase()}/profilePicture.jpg`,
                                                      {
                                                          bucket: "platform-user-media-uploads",
                                                          level: "public"
                                                      }
                                                    ).then((res) => {
                                                      trackPageRequest(fetch(
                                                        res
                                                      )).then((image) => {
                                                        if(image.status == 200){
                                                          profilePicture_uri = res;
                                                        }
                                                        commentsReplyMapArray[r]['profilePictureURI'] = profilePicture_uri
                                                        commentsReplyMapArray[r]['messageReplyID'] = commentsReplyMapArray[r].messageID
                                                        commentsReplyMapArray[r]['likesArray'] = commentsReplyMapArray[r].likesArray
                                                        

                                                        loopCommentsReplyArray(r+1)
                                                      })
                                                    })
                                                  } else {
                                                    commentsMapArray[c]['commentsReplyMapArray'] = commentsReplyMapArray
                                                    loopCommentsArray(c+1)
                                                  }
                                                }

                                                loopCommentsReplyArray(0)


                                              } else {
                                                loopCommentsArray(c+1)
                                              }
                                            })
                                          })
                                        })

                                      } else {

                                        

                                        publishMedia(res);

                                      }
                                    }
                                    publishMedia(res);
                                    loopCommentsArray(0);

                                }
                            }).catch(() => { publishMedia(res); });
                        } else {
                          loopUserMediaArray(m+1);
                        }
                    }).catch(() => { loopUserMediaArray(m+1); })
                  } else {
                
                    function loopUserMediaArrayFinal(m){
                      if(m <= mediaMapArray.length-1){
                        mediaMapArray[m].itemIndex = m;
                        loopUserMediaArrayFinal(m+1)
                      } else {
                        mediaMapArrayUserMap[currentUser] = mediaMapArray

                        that.setState({
                          mediaMapArray,
                          mediaMapArrayUserMap
                        })

                      }
                    }
                    loopUserMediaArrayFinal(0);

                  }
                }
              } else {

                bioString = 'No Bio :('
              }
            })
          }






     
     
    });

  }

  setNativeNotification(generalNoticeText){
    that.setState({
      generalNoticeOverlay: true,
      generalNoticeText
    })
  }

  scrollMedia(_id){
    let id = _id;
    if(id < 2 && that.state.lastMediaItemIndexScrolled < id){
      id = 2
    } else if(id > that.state.mediaMapArray.length-3 && that.state.lastMediaItemIndexScrolled > id){
      id = that.state.mediaMapArray.length-3
    } else if(id > that.state.mediaMapArray.length-1){
      id = 0;
    } else if (id < 0){
      id = that.state.mediaMapArray.length-1
    }

    const element = document.getElementById(id);
    if (element) {
      that.setState({
        lastMediaItemIndexScrolled: id
      })
      element.scrollIntoView({ behavior: 'smooth', block: 'nearest', });
    }
  }


  render(){
      applicantUsername = that.props.username
    
      const { touched } = that.state;
      const className = touched ? 'button1_touched' : 'button1';

      if(navigationHandler(that.state.navigationDestinationObject)){
          return navigationHandler(that.state.navigationDestinationObject)
      }
      const renderProps = { API, AWS, Amplify, Auth, Button, ButtonContent, ButtonGroup, CampaignContract_latest, CampaignFactoryContract_latest, Chart, Component, Container, Form, FormField, Fragment, Header, Icon, Image, LENDERBLOCKADMINWHITELIST, LeftNavBar, Link, List, ListContent, ListDescription, ListHeader, ListIcon, ListItem, ListList, LoadingIcons, Modal, Mosaic, OrbitProgress, PIXELAJUST, Radio, React, Storage, ThreeDot, USDEtherConversionRate, Web3, accountmanagement, addedContracts, addedContracts_creditLine, addedContracts_loanAgreement, allContracts, allContractsLooper, allDaysElapsed, allValues, applicantUsername, awsconfig, axios, bScoreFilterMax, bScoreFilterMin, blenderData, blenderPrivateKey, blenderScore, buttonColorFlashIntervalDefault, cardEntryFormTimer, cardFundComponent, chartData, chartDayRange, checkValidAuthTokenInterval, checkValidAuthTokenIntervalPeriod_ms, city, className, cognitoID, compoundedDebtSum, corporateBackedUsernamesArray, country, countryCodeSwappedJSON, countryCodeSwappedJSONList, countryCodes, countryNames, creditLineAddressArray, creditLineArray, currentLentSum, currentUser, currentUserCap, debounce, emailAddress, ethers, exitFundWalletTimer, exitTutorialTimer_1, exitTutorialTimer_2, exitTutorialTimer_3, fileDialog, filterSwitch, filterSwitchReloaded, firstName, flashCounter, forexJSON, fullAddress, fullName, fundWalletPromptDidBool, intRateMax, intRateMin, isMobile, joinDateSecs, lastName, lastNonce, lenderCtMax, lenderCtMin, lenders, loanAgreementArray, mediaArray, mediaArrayMap, mediaMapArrayUserMap, mimemessage, monthLengtheningEnum, navigationHandler, newMemberRegisterBool, noAccountsWarning_creditLine, noAccountsWarning_loanAgreement, notificationCount, notifs, openBorrowingContractsDetails_loanAgreement, openContracts, openLendingContractsDetails_loanAgreement, openStakingContractsDetails_loanAgreement, optionCountryCodeSwappedJSON, pageOrigin, postalCode, preSortedContractsArray, primaryDisplayCurrency, primaryDisplayPrice, primaryLanguage, privateKey, proposeGasPrice, publicKey, rand1, rand2, rand3, rand4, randSum, ratingMax, ratingMin, recentlyViewedContracts, recentlyViewedContractsArray, resultMessageTimer, retrievedContractsArray, routeProps, scrollHeaderInterval, searchTimer, secondaryDisplayCurrency, secondaryDisplayPrice, squareCustomerID, stakedContractsList, state, street, that, tokenID, tokenLifeTimeLimit, topMoversArray, totalBorrContracts, touched, useLayoutEffect, useParams, useRef, userWishlist, username_wallet, verifyOverlayShownBool, walletBalance, web3, wishlistArray };

      if (isMobile) {
        return <AccountManagementMobileRender {...renderProps} />;
      }

      return <AccountManagementDesktopRender {...renderProps} />;
    }

}


function accountmanagement(props){

  return (<AccountManagementComponent/>)
}

export default accountmanagement;

